import type { FC } from "react";

import classes from "./CenterContentLayout.module.css";
import type { CenterContentLayoutProps } from "./CenterContentLayout.types";

export const CenterContentLayout: FC<CenterContentLayoutProps> = ({
  children,
}) => <div className={classes.container}>{children}</div>;
